import { useNavigate } from "react-router-dom";

const cards = [
    {
        title: "Send Files to Print Shops",
        description:
            "Upload files directly to any print shop's dashboard. No emails, no USB drives, no hassle.",
        cta: "Browse shops",
        href: "/marketplace?filter=shops",
        primary: true,
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="w-[26px] h-[26px] text-white"
            >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" x2="12" y1="3" y2="15" />
            </svg>
        ),
    },
    {
        title: "Discover Print Suppliers",
        description:
            "Find trusted suppliers for paper, toner, equipment, and materials all in your area.",
        cta: "View suppliers",
        href: "/marketplace?filter=suppliers",
        primary: false,
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="w-[26px] h-[26px] text-white"
            >
                <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
            </svg>
        ),
    },
    {
        title: "Find Local Print Specialists",
        description:
            "From banners to custom T-shirts and even specialised mugs. Find trusted local print specialists on our platform.",
        cta: "Learn more",
        href: "/about",
        primary: false,
        purple: true,
        icon: (
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5832 7.00004C14.9054 7.00004 15.1665 6.73887 15.1665 6.41671C15.1665 6.09454 14.9054 5.83337 14.5832 5.83337C14.261 5.83337 13.9999 6.09454 13.9999 6.41671C13.9999 6.73887 14.261 7.00004 14.5832 7.00004Z" fill="white" stroke="white" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19.25 11.6667C19.5721 11.6667 19.8333 11.4056 19.8333 11.0834C19.8333 10.7612 19.5721 10.5001 19.25 10.5001C18.9278 10.5001 18.6666 10.7612 18.6666 11.0834C18.6666 11.4056 18.9278 11.6667 19.25 11.6667Z" fill="white" stroke="white" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8.74996 8.16673C9.07213 8.16673 9.33329 7.90556 9.33329 7.58339C9.33329 7.26123 9.07213 7.00006 8.74996 7.00006C8.42779 7.00006 8.16663 7.26123 8.16663 7.58339C8.16663 7.90556 8.42779 8.16673 8.74996 8.16673Z" fill="white" stroke="white" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.41659 14C6.73875 14 6.99992 13.7389 6.99992 13.4167C6.99992 13.0945 6.73875 12.8334 6.41659 12.8334C6.09442 12.8334 5.83325 13.0945 5.83325 13.4167C5.83325 13.7389 6.09442 14 6.41659 14Z" fill="white" stroke="white" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.8333 1.16669C6.41663 1.16669 1.16663 6.41669 1.16663 12.8334C1.16663 19.25 6.41663 24.5 12.8333 24.5C13.9136 24.5 14.756 23.6297 14.756 22.5307C14.756 22.0209 14.546 21.5565 14.2461 21.2182C13.9078 20.881 13.7351 20.4575 13.7351 19.9057C13.7307 19.6489 13.778 19.3939 13.8742 19.1558C13.9705 18.9177 14.1137 18.7014 14.2952 18.5198C14.4768 18.3382 14.6931 18.195 14.9312 18.0988C15.1693 18.0026 15.4244 17.9553 15.6811 17.9597H18.0098C21.5693 17.9597 24.4906 15.0395 24.4906 11.48C24.4591 5.84735 19.2045 1.16669 12.8333 1.16669Z" stroke="white" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

        ),
    },
];

export default function FeatureCards() {
    const navigate = useNavigate();

    return (
        <section className="bg-white border-b border-[#e4e5e7]">
            <div className="max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[56px] md:py-[80px]">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-[20px]">
                    {cards.map((card) => (
                        <button
                            key={card.title}
                            onClick={() => navigate(card.href)}
                            className={`group relative rounded-[20px] p-[32px] border transition-all text-left no-underline block ${card.primary
                                ? "bg-gradient-to-br from-[#fff8f5] to-white border-[#ffe4db] hover:border-[#ffcab9] hover:shadow-[0px_8px_32px_rgba(255,83,35,0.12)]"
                                : "bg-gradient-to-br from-[#f8f8fa] to-white border-[#e4e5e7] hover:border-[#c0c2c6] hover:shadow-[0px_8px_32px_rgba(0,0,0,0.08)]"
                                }`}
                        >
                            <div
                                className={`w-[56px] h-[56px] rounded-[16px] flex items-center justify-center mb-[20px] ${card.purple
                                    ? "bg-[#7C3AED]"
                                    : card.primary
                                        ? "bg-gradient-to-br from-[#ff5323] to-[#ff8a65]"
                                        : "bg-gradient-to-br from-[#212326] to-[#3a3d42]"
                                    }`}
                            >
                                {card.icon}
                            </div>

                            <h3 className="font-semibold text-[20px] text-[#212326] mb-[8px]">
                                {card.title}
                            </h3>

                            <p className="font-medium text-[14px] text-[#717182] leading-[1.6] mb-[16px]">
                                {card.description}
                            </p>

                            <div
                                className={`flex items-center gap-[6px] font-semibold text-[13px] ${card.primary ? "text-[#ff5323]" : card.purple ? "text-[#7C3AED]" : "text-[#212326]"
                                    }`}
                            >
                                {card.cta}

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    className="w-[14px] h-[14px]"
                                >
                                    <path d="M5 12h14" />
                                    <path d="m12 5 7 7-7 7" />
                                </svg>
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </section>
    );
}
